import { render } from "./HistoriquePrixProduitPage.vue?vue&type=template&id=63a9b57e&ts=true"
import script from "./HistoriquePrixProduitPage.vue?vue&type=script&lang=ts"
export * from "./HistoriquePrixProduitPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__